module.exports = __webpack_public_path__ + "static/social-orcid-a763c1ade5c39c4a95cc0729aefdcfed.png";